import {ContestDetailPredictionResponse} from "../../api/api";
import React, {Fragment} from "react";
import {Button, Card, InputGroup, Stack} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {getPredictionColor} from "../../util/colors";


export const PredictionCard = ({
                                 contestId,
                                 prediction,
                                 value,
                                 setValue,
                                 disabled,
                                 showDetailsLink = false,
                                 showResolution = false
                               }: {
  contestId: string;
  prediction: ContestDetailPredictionResponse,
  value: number,
  setValue: (value: number) => void
  disabled: boolean,
  showDetailsLink?: boolean
  showResolution?: boolean
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(Number(e.target.value));
  };
  return <Card className={"mb-3"}>
    <Card.Header>
      <Card.Title className={"mb-0"}>{prediction.ordinal}. {prediction.text}</Card.Title>
      {prediction.outcomeText ? <Card.Text className={"mt-2"}>{prediction.outcomeText}</Card.Text>
        : prediction.details && <Card.Text className={"mt-2"}>{prediction.details}</Card.Text>}
    </Card.Header>
    <Card.Body>
      <Form.Group controlId={`contest.prediction.${prediction.ordinal}.value`}>
        <Form.Label>Your prediction</Form.Label>
        <Stack direction={"horizontal"} gap={3}>
          <Form.Range
            min={1}
            max={99}
            step={1}
            value={value}
            onChange={handleChange}
            disabled={disabled}
          />
          <InputGroup style={{maxWidth: "120px", minWidth: "100px"}}>
            <Form.Control type="number"
                          value={value}
                          onChange={handleChange}
                          disabled={disabled}
                          min={1}
                          max={99}
                          step={1}
            />
            <InputGroup.Text>%</InputGroup.Text>
          </InputGroup>
        </Stack>
      </Form.Group>
    </Card.Body>
    {(showDetailsLink || showResolution) &&
      <Card.Footer>
        <Stack direction={"horizontal"} gap={3} className={"justify-content-between"}>
          {showResolution ?
            <Fragment>
              {prediction.outcome ?
                <span>Result: <span style={{fontWeight: 'bold'}}>{prediction.outcome.toUpperCase()}</span></span> :
                <span
                  className={"text-muted"}>{expectedResolutionDateMessage(prediction.expectedResolution)}</span>}
              {(prediction.outcome && prediction.score) ? <span>
                Points:{' '}
                <span style={{color: getPredictionColor(value, prediction.outcome), fontWeight: 'bold'}}>
                  {prediction.score}
                </span>
              </span> : null}
            </Fragment> : <span></span>}
          {showDetailsLink ?
            <Button variant={"link"} href={`/predictions/contests/${contestId}/predictions/${prediction.ordinal}`}>View
              details</Button> : <span></span>}
        </Stack>
      </Card.Footer>
    }
  </Card>
}

export const expectedResolutionDateMessage = (isoDate: string): string => {
  const target = new Date(isoDate);
  const now = new Date();

  const diffMs = target.getTime() - now.getTime();
  if (diffMs <= 0) return "Result expected soon.";

  const diffDaysTotal = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDaysTotal < 1) return "Result expected soon.";

  const years = Math.floor(diffDaysTotal / 365);
  const months = Math.floor((diffDaysTotal % 365) / 30);
  const days = (diffDaysTotal % 365) % 30;

  if (years >= 1) {
    let msg = `Result expected in ${years} year${years > 1 ? "s" : ""}`;
    if (months > 0) msg += ` and ${months} month${months > 1 ? "s" : ""}`;
    return msg + '.';
  }

  if (months >= 1) {
    let msg = `Result expected in ${months} month${months > 1 ? "s" : ""}`;
    if (days > 0) msg += ` and ${days} day${days > 1 ? "s" : ""}`;
    return msg + '.';
  }

  return `Result expected in ${diffDaysTotal} day${diffDaysTotal > 1 ? "s" : ""}.`;
};
